import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { get } from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

import { getPatientFoodDetails, approveFoodItem, resetField } from "../../../../store/actions";
import { foodItemSteps } from "./formHelper";

const PatientFoodItemTabs = ({ foodId, isAdmin, foodDetails, getPatientFoodDetails, approveFoodItem, history, resetField }) => {
	const [activeTab, setActiveTab] = useState(0);

	useEffect(() => {
		if (!foodId) {
			setActiveTab(0);
		} else {
			getPatientFoodDetails(`${foodId}/approve_food`);
		}
	}, [foodId, getPatientFoodDetails]);

	useEffect(() => {
		return () => {
			resetField("FoodDatabase.getPatientFoodItem", {});
		};
	}, [resetField]);

	const saveAndPublish = (saved = true) => {
		if (saved) {
			approveFoodItem(foodId) && NotificationManager.success("Food item saved and approved!", "", 5000);
		}

		if (isAdmin) {
			history.push(`/nutrition/food-database/approval`);
		} else {
			history.push(`/nutrition/myfood`);
		}
	};

	const renderTabs = () => {
		return foodItemSteps.map((step, i) => {
			const SpecificStep = step.component;
			return (
				<Tab key={step.id} eventKey={i} title={step.title} disabled={!foodId}>
					<SpecificStep
						setActiveTab={setActiveTab}
						initialValues={foodDetails}
						foodId={foodId}
						saveAndPublish={saveAndPublish}
						refetchFoodItem={() => getPatientFoodDetails(foodId)}
						history={history}
						isAdmin={isAdmin}
					/>
				</Tab>
			);
		});
	};

	return (
		<React.Fragment>
			<Tabs activeKey={activeTab} className="pt-2" onSelect={(tabNumber) => setActiveTab(Number(tabNumber))}>
				{renderTabs()}
			</Tabs>
			<div className="tab-status-text">Step {`${activeTab + 1} - ${foodItemSteps.length}`}</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	const { FoodDatabase, Auth } = state;
	return {
		foodDetails: get(FoodDatabase, "getPatientFoodItem", {}),
		isAdmin: get(Auth, "isAdmin", false),
	};
};

const mapDispatchToProps = { getPatientFoodDetails, approveFoodItem, resetField };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PatientFoodItemTabs));
